<ng-container *ngIf="customerLanding$ | async; let customerLanding">
    <div fxLayout="column" class="onBoarding-wrapper">
        <div class="top-part-wrapper" style="background-image: url('assets/images/dashboard-backgroud-min.jpg')">
            <div class="layer"></div>
            <div fxLayoutAlign="center center" fxLayout.lt-md="column" fxL class="top-part">
                <div
                    class="main-info-wrapper"
                    fxLayout="column"
                    fxLayoutGap="1em"
                    fxLayoutGap.lt-md="0.5em"
                    fxLayoutAlign="center center"
                >
                    <h1 class="white">KlickData <strong class="red">KLMS</strong></h1>
                    <h2 class="white mb-5" i18n="@@onboardingIntro">
                        A powerful tool to easily <i class="red"> educate, certify </i> and
                        <i class="red">follow up </i>
                        <br />
                        learning development with a
                        <br />
                        complete Learning Management System
                    </h2>
                    <!-- <ng-container *ngIf="!(isMobile | async)" [ngTemplateOutlet]="beforeRegisterText"> </ng-container> -->

                    <ng-container *ngIf="customerLanding.enable_anonymous_register">
                        <h3 class="red mb-5">
                            <strong i18n="@@signUpToKlickDataKLMS.ForFree!">
                                Sign up to KlickData KLMS.<br fxHide.gt-sm />
                                For Free!
                            </strong>
                        </h3>
                        <div fxLayoutAlign="space-between center" class="wrapper-btns" fxLayout="column">
                            <button mat-raised-button class="register-btn" routerLink="../signup" i18n="@@register">
                                Register
                            </button>
                            <p class="white">
                                <strong class="gap-5">
                                    <span i18n="alreadyRegistered?">Already registered?</span>
                                    <span class="pointer red" i18n routerLink="../login">Click here to login</span>
                                </strong>
                            </p>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="!customerLanding.enable_anonymous_register">
                        <h3 class="red mb-5">
                            <strong i18n="@@signUpToKlickDataKLMS.ForFree!">
                                Login to KlickData KLMS.<br fxHide.gt-sm />
                            </strong>
                        </h3>
                        <div fxLayoutAlign="space-between center" class="wrapper-btns" fxLayout="column">
                            <button mat-raised-button class="register-btn" routerLink="../login" i18n="@@register">
                                Login
                            </button>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="search-part-wrapper" style="background-image: url('assets/images/search-background-min.jpg')">
            <div class="layer-search"></div>
            <div fxLayoutAlign="center center" class="middle-part" fxLayout.lt-md="column">
                <div
                    class="left-info-wrapper"
                    fxHide.lt-md
                    fxFlex="1 1 30%"
                    fxLayout="column"
                    fxLayoutAlign="center center"
                >
                    <img fxHide="true" src="assets/images/KD_KOL_logo_long.png" />
                    <p fxHide="true" i18n="@@KOLIsOurPublicDataBase">
                        KlickData Open Library (KOL) is our public database of online courses that users can access for
                        thier skills development.
                    </p>
                </div>
                <div
                    class="search-box"
                    fxFlex="1 1 40%"
                    fxFlex.lt-md="1 1 95%"
                    fxLayout="column"
                    fxLayoutAlign="center center"
                >
                    <h1 class="mt-0 blue"><strong i18n="@@searchCourse">Search Course</strong></h1>
                    <app-search class="search-onoarding" [inOnboarding]="true"></app-search>
                </div>
                <div fxHide.lt-md fxFlex="1 1 30%"></div>
                <ng-container *ngIf="isMobile | async" [ngTemplateOutlet]="feelFreeText"> </ng-container>
            </div>
        </div>
        <ng-container *ngIf="!(isMobile | async)" [ngTemplateOutlet]="feelFreeText"> </ng-container>
        <div class="search-result onboarding">
            <router-outlet></router-outlet>
        </div>
        <div fxFlex="1 1 100%" fxLayout="column" fxLayoutAlign="center center" class="sales-part">
            <h2 (click)="openLink()" i18n="@@whyKDIsThePerfect">
                Why <span class="red"> KlickData <strong>KLMS</strong></span> is the perfect education platform for any
                organization!
            </h2>
            <div fxFlex="1 1 100%" fxLayout="row" fxLayoutAlign="center center"></div>
        </div>
    </div>
</ng-container>
<ng-template #signUpForm>
    <div class="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
        <h3 class="red">
            <strong i18n="@@signUpToKlickDataKLMS.ForFree!">
                Sign up to KlickData KLMS.<br fxHide.gt-sm />
                For Free!
            </strong>
        </h3>
        <ng-container *ngIf="!(isMobile | async)" [ngTemplateOutlet]="beforeRegisterText"> </ng-container>
        <app-signup></app-signup>
        <ng-container *ngIf="isMobile | async" [ngTemplateOutlet]="beforeRegisterText"> </ng-container>
    </div>
</ng-template>
<ng-template #beforeRegisterText>
    <p class="white m-0" i18n>
        Klick Data Learning Management System has plenty of great online courses.<br />
        Enjoy and Explore with a free account to KLMS. No credit card required. Welcome!
    </p>
</ng-template>
<ng-template #feelFreeText>
    <h3 class="search-phrase blue" i18n="@@feelFreeToSearchOrBrowseOurLibraryOfOpenCourses">
        Feel free to search or browse our library of open online courses
    </h3>
</ng-template>
